import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export const createOnlyOneSatisfiesConditionValidator = <TFormArrayMemberControlValue>(
  conditionToSatisfy: (value: TFormArrayMemberControlValue | null) => boolean,
  multipleSatisfiesErrorKey?: string
): ValidatorFn => {
  const oneOnlyOneSatisfiesConditionValidator: ValidatorFn = (control: FormArray) => {
    let conditionSatisfied = false;
    for (let i = 0; i < control.length; i++) {
      const currentValue = control.at(i).value as TFormArrayMemberControlValue | null;
      if (conditionToSatisfy(currentValue)) {
        if (conditionSatisfied) {
          const error: ValidationErrors = {};
          error[multipleSatisfiesErrorKey || 'multipleSatisfiedCondition'] = true;
          return error;
        }
        conditionSatisfied = true;
      }
    }
    return null;
  };

  return oneOnlyOneSatisfiesConditionValidator;
};
